/**
 * Auto-generated at build time. Do not edit.
 * Injected by scripts/inject-build-info.js
 */

export const APP_VERSION = "1.30.1";
export const BUILD_DATE = "2026-10-30";
